import { useSelector } from 'react-redux';
import {
  useQuery,
  DocumentNode,
  ApolloError,
  ApolloQueryResult,
  OperationVariables,
} from '@apollo/client';
import { RootState } from '../../../../store/store';
import { PaginationInput } from '../../../../types/schema/utils.types';
import { Quotation } from '../../../../types/schema/quotation.types';

interface GetAllQuotationsByPageHook {
  data: Quotation[] | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      getAllQuotationsByPage: Quotation[];
    }>
  >;
}

interface GetAllQuotationsByPageMutationData {
  getAllQuotationsByPage: Quotation[];
}

interface GetAllQuotationsByPageInputType {
  input: PaginationInput;
}

export function useGetAllQuotationsByPage(
  query: DocumentNode,
  input: PaginationInput
): GetAllQuotationsByPageHook {
  const { jwt } = useSelector((state: RootState) => state.auth);

  const { data, loading, error, refetch } = useQuery<
    GetAllQuotationsByPageMutationData,
    GetAllQuotationsByPageInputType
  >(query, {
    variables: {
      input,
    },
    context: {
      headers: {
        cookie: `jwt=${jwt}`,
        authorization: jwt ? `Bearer ${jwt}` : '',
      },
    },
  });

  return {
    data: data?.getAllQuotationsByPage,
    loading,
    error,
    refetch,
  };
}
